export default __webpack_public_path__ + "static/media/05.0007125c.jpg";